import { useEffect, useState } from "react";
import { AppDialog } from "../components/AppDialog/AppDialog";
import { PreReservationFormFields } from "./PreReservationFormFields";
import { usePreReservationFormAnswers } from "./usePreReservationFormAnswers";
import styles from "./PreReservationFormDialog.module.scss";

interface IPreReservationFormDialogProps {
  visible: boolean;
  formName: string;
  templateText: string;
  contextValues: Record<string, string>;
  onAgree: (answers: string[]) => void;
  onDisagree: () => void;
}

export const PreReservationFormDialog = ({
  visible,
  formName,
  templateText,
  contextValues,
  onAgree,
  onDisagree,
}: IPreReservationFormDialogProps) => {
  // The dialog stays mounted between openings (only `visible` toggles), so the
  // previous target's answers are wiped whenever it opens or the template changes.
  const { segments, answers, setAnswer, isInvalid, showMissingError, collectAnswers } =
    usePreReservationFormAnswers(templateText, visible);

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setSubmitted(false);
  }, [visible, templateText]);

  const handleAgree = () => {
    if (submitted) {
      return;
    }
    const collected = collectAnswers();
    if (!collected) {
      return;
    }
    setSubmitted(true);
    onAgree(collected);
  };

  return (
    <AppDialog
      visible={visible}
      onHide={onDisagree}
      header={formName}
      className={styles.dialog}
    >
      <div className={styles.root}>
        <div className={styles.body}>
          <PreReservationFormFields
            segments={segments}
            contextValues={contextValues}
            answers={answers}
            onAnswerChange={setAnswer}
            isInvalid={isInvalid}
          />
        </div>

        {showMissingError && (
          <div className={styles.error}>Моля попълнете всички полета.</div>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.disagree}
            disabled={submitted}
            onClick={onDisagree}
          >
            Не приемам
          </button>
          <button
            type="button"
            className={styles.agree}
            disabled={submitted}
            onClick={handleAgree}
          >
            Приемам
          </button>
        </div>
      </div>
    </AppDialog>
  );
};
